import { render, staticRenderFns } from "./DownloadStat.vue?vue&type=template&id=7ca1aec4&scoped=true&"
import script from "./DownloadStat.vue?vue&type=script&lang=js&"
export * from "./DownloadStat.vue?vue&type=script&lang=js&"
import style0 from "./DownloadStat.vue?vue&type=style&index=0&id=7ca1aec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca1aec4",
  null
  
)

export default component.exports